module.exports = __webpack_public_path__ + "img/img46.78e92ad3.svg";